var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4946_8935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4094 14.0915C8.28781 14.9705 9.71242 14.9709 10.5914 14.0925C10.5917 14.0922 10.5921 14.0919 10.5924 14.0915L13.0006 11.6833C13.2785 11.376 13.2546 10.9017 12.9474 10.6239C12.6613 10.3653 12.2257 10.3658 11.9402 10.625L9.74567 12.8203L9.75091 1.25002C9.75088 0.835777 9.4151 0.5 9.00089 0.5C8.58668 0.5 8.2509 0.835777 8.2509 1.24999L8.24415 12.806L6.06165 10.625C5.76859 10.3321 5.29363 10.3323 5.00077 10.6254C4.70792 10.9184 4.7081 11.3934 5.00116 11.6863L7.4094 14.0915Z",
    fill: "#1D4650"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12.5C16.8358 12.5 16.5 12.8358 16.5 13.25V16.25C16.5 16.6642 16.1642 17 15.75 17H2.25C1.83579 17 1.50001 16.6642 1.50001 16.25V13.25C1.50001 12.8358 1.16423 12.5 0.750023 12.5C0.335777 12.5 0 12.8358 0 13.25V16.25C0 17.4926 1.00737 18.5 2.25 18.5H15.75C16.9926 18.5 18 17.4926 18 16.25V13.25C18 12.8358 17.6642 12.5 17.25 12.5Z",
    fill: "#1D4650"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4946_8935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6a241ff5ca7f1e46da0c895ea4421b56.svg";
export { ForwardRef as ReactComponent };